import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormElementComponent } from '../form-element/form-element.component';

@Component({
    selector: 'app-switcheable-chip',
    templateUrl: './switcheable-chip.component.html',
    styleUrl: './switcheable-chip.component.scss'
})
export class SwitcheableChipComponent extends FormElementComponent implements OnInit {
    @Input() text: string = '';
    //this component has two types: ('close' => icon = X default   ) and ('add' => icon = + )
    @Input() active: boolean=false;
    @Input() override disabled!: boolean;
    @Input()loading: boolean = false;

    @Input() buttonClass: string = '';
    @Input() textClass: string = '';
    @Input() activeBgColor: string = '';
    @Input() inactiveBgColor: string = '';

     internalActive = false;

    @Output() change = new EventEmitter();

    constructor() {
        super();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['active']) {
          this.internalActive = this.active;
        }
      }

      onChange() {
        if (!this.disabled) {
          this.internalActive = !this.internalActive;
          this.change.emit(this.internalActive);
        }
      }

    getError() { }

    getBackgroundStyle(): { [key: string]: string } {
        return {
          'background-color': this.internalActive ? this.activeBgColor || '#846BB8' : this.inactiveBgColor || '#fff',
          'opacity': this.disabled ? '0.5' : '1',
          'cursor': this.disabled ? 'default' : 'pointer'
        };
      }
      getCloseBtnBackgroundStyle(): { [key: string]: string } {
        return {
          'background-color': this.internalActive
            ? (this.activeBgColor ? this.activeBgColor : '#4A2F8F') // activo
            : '#a9a9a9',                                            // inactivo
        };
      }

      getTextColorStyle(): { [key: string]: string } {
        return {
          'color': this.internalActive ? 'white' : '#a9a9a9'
        };
      }


}
